import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'SSBIConductAbsent',
    label: 'SSBIConductAbsent',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
